<template>
  <div>
    <Jumbotron title="" />

    <!-- dekstop -->
    <b-container class="d-none d-sm-block" style="margin-top: -10em;">
      <!-- order header -->
      <b-row>
        <b-col v-if="order_data.country_text" class="m-3 p-4 sg-rounded-container or-header sg-bg-header" :style="{'background-image': 'url(' + require('@/assets/img/logo-notext-bw.png' ) + ')'}">
          <Header
            :key="keyComponent"
            :order_data="order_data"
            @changeCountryCity="changeCountryCity"
            @changeDate="changeDate"
            @changeInterest="changeInterest"
            />
        </b-col>

        <b-col v-else class="m-3 p-4 sg-rounded-container or-header center-base all">
          <b-spinner variant="primary" type="grow" label="Spinning" />
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="8">
          <!-- service detail -->
          <b-row>
            <b-col v-if="order_data.service_text" class="m-3 p-4 sg-rounded-container or-detail">
              <ServiceDetail
              :key="keyComponent"
              :name="order_data.service_text.name"
              :min_pax="order_data.service_text.min_pax"
              :max_pax="order_data.service_text.max_pax"
              :duration="order_data.service_text.duration"
              :description="order_data.service_text.description"
              :more_service_options="more_service_options"
              @changeService="changeService"
            />
            </b-col>

            <b-col v-else class="m-3 p-4 sg-rounded-container or-detail center-base all">
              <b-spinner variant="primary" type="grow" label="Spinning" />
            </b-col>
          </b-row>

          <!-- list of passenger -->
          <b-row v-for="(x, i) in order_paxs" :key="i">
            <b-col class="m-3">
              <PassengerDetail
                :key="keyComponent"
                :order_paxs="order_paxs[i]"
                :index="i"
                @appendFormData="appendFormData"
              />
            </b-col>
          </b-row>

          <!-- add more person -->
          <b-row>
            <b-col class="m-3 p-4" :class="remain_pax > 0 ? 'sg-rounded-container cursor-pointer' : 'sg-rounded-muted'">
              <b-row class="center-base between" @click="addMorePassenger">
                <b-col cols="6">
                  <span style="font-size: 1.5em; font-weight: 700; color: #233c7c;">
                    Add More Person <b-badge :variant="remain_pax > 0 ? 'success' : 'secondary'">{{ remain_pax }}</b-badge>
                  </span>
                </b-col>

                <b-col cols="2" class="text-right">
                  <font-awesome-icon v-if="remain_pax > 0" icon="plus" style="font-size: 2em; font-weight: 700; color: #f27137;" />
                  <font-awesome-icon v-else icon="plus" style="font-size: 2em; font-weight: 700; color: #728294;" />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>

        <b-col cols="4">
          <!-- additional detail -->
          <b-row>
            <b-col class="m-3 p-4 sg-rounded-container or-additional">
              <AdditionalDetail />
            </b-col>
          </b-row>

          <!-- price detail -->
          <b-row>
            <b-col v-if="calculationComplete" class="m-3 p-4 sg-rounded-container or-price">
              <PriceDetail
                :key="keyComponent"
                :items="items"
                :final_currency="final_currency"
                :final_price="final_price"
              />
            </b-col>

            <b-col v-else class="m-3 p-4 sg-rounded-container or-price center-base all">
              <b-spinner variant="primary" type="grow" label="Spinning" />
            </b-col>
          </b-row>

          <!-- button -->
          <b-row>
            <b-col class="m-3 p-3 sg-order-button center-base all" @click="createOrder" :disabled="order_button_state">
              Continue to Payment &nbsp;
              <font-awesome-icon icon="angle-right" style="font-size: 28px;" />
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row class="mt-5" />
    </b-container>

    <!-- mobile -->
    <b-container class="d-block d-sm-none" style="margin-top: -5em;">
      <!-- order header -->
      <b-row>
        <b-col v-if="order_data.country_text" class="m-3 p-4 sg-rounded-container or-header sg-bg-header" :style="{'background-image': 'url(' + require('@/assets/img/logo-notext-bw.png' ) + ')'}">
          <Header
            :key="keyComponent"
            :order_data="order_data"
            @changeCountryCity="changeCountryCity"
            @changeDate="changeDate"
            @changeInterest="changeInterest"
            />
        </b-col>

        <b-col v-else class="m-3 p-4 sg-rounded-container or-header center-base all">
          <b-spinner variant="primary" type="grow" label="Spinning" />
        </b-col>
      </b-row>

      <!-- service detail -->
      <b-row>
        <b-col v-if="order_data.service_text" class="m-3 p-4 sg-rounded-container or-detail">
          <ServiceDetail
          :key="keyComponent"
          :name="order_data.service_text.name"
          :min_pax="order_data.service_text.min_pax"
          :max_pax="order_data.service_text.max_pax"
          :duration="order_data.service_text.duration"
          :description="order_data.service_text.description"
          :more_service_options="more_service_options"
          @changeService="changeService"
        />
        </b-col>

        <b-col v-else class="m-3 p-4 sg-rounded-container or-detail center-base all">
          <b-spinner variant="primary" type="grow" label="Spinning" />
        </b-col>
      </b-row>

      <!-- list of passenger -->
      <b-row v-for="(x, i) in order_paxs" :key="i">
        <b-col class="m-3">
          <PassengerDetail
            :key="keyComponent"
            :order_paxs="order_paxs[i]"
            :index="i"
            @appendFormData="appendFormData"
          />
        </b-col>
      </b-row>

      <!-- add more person -->
      <b-row>
        <b-col class="m-3 p-4" :class="remain_pax > 0 ? 'sg-rounded-container cursor-pointer' : 'sg-rounded-muted'">
          <b-row class="center-base between" @click="addMorePassenger">
            <b-col cols="10">
              <span style="font-size: 1.2em; font-weight: 700; color: #233c7c;">
                Add More Person <b-badge :variant="remain_pax > 0 ? 'success' : 'secondary'">{{ remain_pax }}</b-badge>
              </span>
            </b-col>

            <b-col cols="2" class="text-right">
              <font-awesome-icon v-if="remain_pax > 0" icon="plus" style="font-size: 1.5em; font-weight: 700; color: #f27137;" />
              <font-awesome-icon v-else icon="plus" style="font-size: 1.5em; font-weight: 700; color: #728294;" />
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <!-- additional detail -->
      <b-row>
        <b-col class="m-3 p-4 sg-rounded-container or-additional">
          <AdditionalDetail />
        </b-col>
      </b-row>

      <!-- price detail -->
      <b-row>
        <b-col v-if="calculationComplete" class="m-3 p-4 sg-rounded-container or-price">
          <PriceDetail
            :key="keyComponent"
            :items="items"
            :final_currency="final_currency"
            :final_price="final_price"
          />
        </b-col>

        <b-col v-else class="m-3 p-4 sg-rounded-container or-price center-base all">
          <b-spinner variant="primary" type="grow" label="Spinning" />
        </b-col>
      </b-row>

      <!-- button -->
      <b-row>
        <b-col class="m-3 p-3 sg-order-button center-base all" @click="createOrder" :disabled="order_button_state">
          Continue to Payment &nbsp;
          <font-awesome-icon icon="angle-right" style="font-size: 28px;" />
        </b-col>
      </b-row>
    </b-container>

    <!-- MODAL COUNTRY CITY -->
    <b-modal
      ref="country-city-modal"
      centered
      size="lg"
      hide-header
      hide-footer
    >
      <ModalCountryCity
        :country="order_data.country"
        :city="order_data.city"
        :country_city_options="country_city_options"
        @setCountryCity="setCountryCity"
      />
    </b-modal>

    <!-- MODAL DATE -->
    <b-modal
      ref="date-modal"
      centered
      size="lg"
      hide-header
      hide-footer
    >
      <ModalDate
        :start_date="order_data.start_date"
        :end_date="order_data.end_date"
        @setDate="setDate"
      />
    </b-modal>

    <!-- MODAL INTEREST -->
    <b-modal
      ref="interest-modal"
      centered
      size="lg"
      hide-header
      hide-footer
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
    >
      <ModalInterest
        :interest="order_data.interest"
        :interest_options="interest_options"
        @setInterest="setInterest"
      />
    </b-modal>

    <!-- MODAL SERVICE -->
    <b-modal
      ref="service-modal"
      centered
      size="lg"
      hide-header
      hide-footer
    >
      <ModalService
        :service="order_data.service"
        :service_options="service_options"
        @setService="setService"
      />
    </b-modal>
  </div>
</template>

<script>
// external dependencies
import swal from 'sweetalert'
import moment from 'moment'
import VueJwtDecode from 'vue-jwt-decode'

// custom components
import Jumbotron from '@/components/Jumbotron'

import Header from '@/components/Order/Header'
import ServiceDetail from '@/components/Order/ServiceDetail'
import PassengerDetail from '@/components/Order/PassengerDetail'
import AdditionalDetail from '@/components/Order/AdditionalDetail'
import PriceDetail from '@/components/Order/PriceDetail'

import ModalCountryCity from '@/components/Order/ModalCountryCity'
import ModalDate from '@/components/Order/ModalDate'
import ModalInterest from '@/components/Order/ModalInterest'
import ModalService from '@/components/Order/ModalService'

// api call
import AdminCountryAPI from '@/api/AdminCountryAPI'
import AdminInterestAPI from '@/api/AdminInterestAPI'
import AdminServiceAPI from '@/api/AdminServiceAPI'
import OrderAPI from '@/api/OrderAPI'
import PaymentAPI from '@/api/PaymentAPI'

export default {
  name: 'Order',
  components: {
    Jumbotron,

    Header,
    ServiceDetail,
    PassengerDetail,
    AdditionalDetail,
    PriceDetail,

    ModalCountryCity,
    ModalDate,
    ModalInterest,
    ModalService
  },
  data () {
    return {
      country_city_options: [],
      interest_options: [],
      service_options: [],
      more_service_options: [
        // {
        //   logo: 'starroad-notext',
        //   name: 'Car Rental',
        //   description: 'Have a more pleasant journey by automobile.',
        //   currency: '€',
        //   price: 50
        // },
        // {
        //   logo: 'startrip-notext',
        //   name: 'Mobile Wifi',
        //   description: 'Stay connected with the world using our Mi-Fi Rental.',
        //   currency: '€',
        //   price: 20
        // }
      ],

      items: [],
      exchangeRate: 0,
      final_currency: 'IDR',
      final_price: 0,

      remain_pax: 0,
      order_paxs: [],
      orderFormData: new FormData(), // supaya bisa upload file

      calculationComplete: false,

      keyComponent: 0,
      order_button_state: false,
      errors: []
    }
  },
  beforeCreate: function () {
    if (this.$session.get('jwt') && this.$session.exists()) {
      let decode = VueJwtDecode.decode(this.$session.get('jwt'))
      this.user = decode

      this.order_data = this.$cookies.get('order_data')
      this.order_data.user = this.user._id
    } else {
      this.order_data = null

      this.$router.push({
        name: 'Login',
        params: {
          whereTo: 'Order'
        }
      })
    }
  },
  created: function () {
    const self = this

    const promise1 = self.fetchAllCountry()
    const promise2 = self.fetchAllInterest()
    const promise3 = self.fetchServiceByCountry(self.order_data.country)

    Promise.all([promise1, promise2, promise3]).then(() => {
      self.reloadReadableData()

      self.forceRerender()
      self.addMorePassenger()
    })
  },
  methods: {
    // PREREQUISITES
    forceRerender: function () {
      // value nya gak auto ke update stlh di ambil dr DB
      this.keyComponent += 1
    },
    reloadReadableData: function () {
      // ganti format data
      this.order_data.start_date_text = moment(this.order_data.start_date, 'DD/MM/YYYY').format('ll')
      this.order_data.end_date_text = moment(this.order_data.end_date, 'DD/MM/YYYY').format('ll')

      // ganti objectID -> country & city name
      this.country_city_options.forEach(country => {
        if (country._id === this.order_data.country) {
          this.order_data.country_text = `${country.country_name}`

          country.city.forEach(city => {
            if (city._id === this.order_data.city) {
              this.order_data.city_text = `${city.city_name}`
            }
          })
        }
      })

      // ganti objectID -> service name, price, etc
      this.service_options.forEach(so => {
        if (so._id === this.order_data.service) {
          this.order_data.service_text = {
            name: so.sgms_service_type_id.service_name,
            currency: so.currency,
            price: so.price,
            min_pax: so.sgms_service_type_id.min_pax,
            max_pax: so.sgms_service_type_id.max_pax,
            duration: so.sgms_service_type_id.duration,
            description: so.sgms_service_type_id.description
          }
        }
      })

      // ganti array ObjectID -> interest name
      let x = []
      this.interest_options.forEach(y => {
        this.order_data.interest.forEach((a, index) => {
          if (y._id === this.order_data.interest[index]) {
            x.push(y.interest)
          }
        })
      })
      this.order_data.interest_text = x.join(', ')

      this.remain_pax = this.order_data.service_text.max_pax

      // ambil currency exchange rate dulu
      this.calculationComplete = false
      this.getCurrentEuro().then(() => {
        // masukin service yg dipilih ke items untuk dihitung harga total nya
        this.items[0] = {
          name: this.order_data.service_text.name,
          qty: this.order_data.duration,
          currency: this.order_data.service_text.currency,
          currencyIDR: 'IDR',
          price: this.order_data.service_text.price,
          priceIDR: this.order_data.service_text.price * this.exchangeRate // mandatory dr snap harus pake IDR
        }

        // hitung ulang price detail
        this.final_price = 0
        for (let i = 0; i < this.items.length; i++) {
          this.final_price += (this.items[i]['qty'] * this.items[i]['priceIDR'])
        }
        this.calculationComplete = true

        // need to force render to update data on child's component
        this.forceRerender()
      })
    },
    addMorePassenger: function () {
      this.order_paxs.push({
        first_name: '',
        last_name: '',
        gender: null
      })

      this.remain_pax--
    },
    appendFormData: function (e) {
      let fileList = e.target.files

      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return

      if (!fileList.length) return

      // append the files to FormData
      Array
        .from(Array(fileList.length).keys())
        .map(x => {
          if (this.orderFormData.get(e.target.name)) {
            this.orderFormData.set(e.target.name, fileList[x], fileList[x].name)
          } else {
            this.orderFormData.append(e.target.name, fileList[x], fileList[x].name)
          }
        })
    },
    // END PREREQUISITES

    // MODAL
    changeCountryCity: function () {
      this.$refs['country-city-modal'].show()
    },
    setCountryCity: function (newCountry, newCity) {
      this.order_data.country = newCountry
      this.order_data.city = newCity

      this.reloadReadableData()

      setTimeout(() => {
        this.$refs['country-city-modal'].hide()
      }, 750)
    },

    changeDate: function () {
      this.$refs['date-modal'].show()
    },
    setDate: function (newDate) {
      this.order_data.start_date = moment(newDate.start).format('DD/MM/YYYY')
      this.order_data.end_date = moment(newDate.end).format('DD/MM/YYYY')
      this.order_data.duration = moment(newDate.end).diff(moment(newDate.start), 'days') + 1

      this.reloadReadableData()

      setTimeout(() => {
        this.$refs['date-modal'].hide()
      }, 500)
    },

    changeInterest: function () {
      this.$refs['interest-modal'].show()
    },
    setInterest: function (newInterest) {
      // copy clone ke original
      this.order_data.interest = JSON.parse(JSON.stringify(newInterest))

      this.reloadReadableData()

      setTimeout(() => {
        this.$refs['interest-modal'].hide()
      }, 750)
    },

    changeService: function () {
      this.$refs['service-modal'].show()
    },
    setService: function (newService) {
      if (newService === null) {
        this.order_data.service = null
        this.order_data.service_text = null

        this.changeService()
      } else {
        this.order_data.service = newService

        this.reloadReadableData()

        setTimeout(() => {
          this.$refs['service-modal'].hide()
        }, 750)
      }
    },
    // END MODAL

    // HTTP REQUEST
    getCurrentEuro: async function () {
      return new Promise((resolve) => {
        PaymentAPI.getCurrentEuro().then((response) => {
          this.exchangeRate = parseInt(response.data.rate.value)

          resolve()
        })
      })
    },
    fetchAllCountry: function () {
      const self = this
      return new Promise((resolve) => {
        AdminCountryAPI.fetchAll().then((response) => {
          self.country_city_options = response.data.country
          resolve()
        })
      })
    },
    fetchAllInterest: function () {
      const self = this
      return new Promise((resolve) => {
        AdminInterestAPI.fetchAll().then((response) => {
          self.interest_options = response.data.interest
          resolve()
        })
      })
    },
    fetchServiceByCountry: function (countryId) {
      const self = this
      return new Promise((resolve) => {
        // empty options, because fetchServiceByCountry is called multiple time
        self.service_options = []

        AdminServiceAPI.fetchByCountry({ sgms_country_id: countryId }).then((response) => {
          self.service_options = response.data.service
          resolve()
        })
      })
    },
    createOrder: async function () {
      let flag = 0
      let self = this

      this.order_button_state = true

      if (flag > 0) {
        swal({
          title: 'Whoops!',
          text: 'Please check your input again.',
          icon: 'error',
          button: {
            text: 'Ok'
          }
        })

        this.order_button_state = false
      } else {
        // append order_data to formData
        for (let key in self.order_data) {
          self.orderFormData.append(key, self.order_data[key])
        }
        // append order_paxs to formData
        let i = 0
        for (let x in self.order_paxs) {
          for (let y in self.order_paxs[x]) {
            self.orderFormData.append(`pax_${i}_${y}`, self.order_paxs[x][y])
          }
          i++
        }

        await OrderAPI.createOrder(self.orderFormData).then(function (res) {
          if (res.status === 200) {
            let items = []
            self.service_options.forEach(so => {
              if (so._id === self.order_data.service) {
                items.push({
                  name: so.sgms_service_type_id.service_name,
                  desc: so.sgms_service_type_id.description.join(' '),
                  qty: self.order_data.duration,
                  currency: so.currency,
                  price: so.price
                })
              }
            })

            self.$cookies.remove('order_data')

            self.$cookies.set('payment_data', {
              tgbs_order_id: res.data.order._id,
              order_id: res.data.order.order_id,
              type_of_user: 'cs',
              type_of_order: 'order',
              items
            })

            self.$router.push({name: 'Pay_Now'})
          } else {
            swal({
              title: 'WHOOPS!',
              text: 'We couldn\'t process your order. Please try again.',
              icon: 'error',
              button: {
                text: 'Ok'
              }
            })
          }
        })
      }
    }
    // END HTTP REQUEST
  }
}
</script>

<style>
.sg-rounded-container.or-header {
  min-height: 100px;

  padding-right: 50px;
  background-size: 12em;
  background-repeat: no-repeat;
  background-position: right;
  background-origin: content-box;
}
.sg-rounded-container.or-detail,
.sg-rounded-container.or-additional,
.sg-rounded-container.or-price {
  min-height: 100px;
}
.sg-rounded-muted {
  background-color: #efefef;
  border-radius: 15px;

  /* x,y, blur, spread color */
  box-shadow: 0px 5px 6px 0px rgba(0, 0, 0, 0.1);
}

.sg-order-button {
  cursor: pointer;

  background-color: #f27137;
  color: white;
  border-radius: 15px;

  text-align: center;
  font-size: 24px;
  font-weight: 900;
}

/* remove bootstrap modal default style */
.modal-content {
  border: 0px solid !important;
  background-color: transparent !important;
}
.modal-body {
  border-radius: 15px;
  border: 0px solid !important;
  background-color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Order.vue